module.exports = __webpack_public_path__ + "static/media/udemy_logo.ec656d1d.png";